// extracted by mini-css-extract-plugin
export default {"socialSharing":"SocialSharing_socialSharing__p3OmV","socialSharing__link":"SocialSharing_socialSharing__link__2qTk9"};